<template>
  <!-- Modal pour fin de cycle -->
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="card">
        <div class="modal-header border-0 mb-2">
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
          ></button>
        </div>

        <!-- Contenu initial du modal -->
        <div v-if="!isConfirmed" class="modal-body pb-4">
          <div class="mb-3 text-center mt-n3">
            <i class="fas fa-graduation-cap text-warning me-2 fs-2"></i>
            <h5
              class="modal-title mt-3 fw-bold d-flex mx-auto"
              id="repeatClassModalLabel"
              style="width: max-content"
            >
              {{ $t("studentlist.confirm_endcycle") }}
              <div class="mx-1 border-bottom border-warning" id="span-number">
                {{ registrationNumbers.length }}
              </div>
              {{ $t("studentlist.confirm_endcycle1") }}
            </h5>
          </div>

          <div class="content mt-n2 w-80 text-center mx-auto">
            <p style="font-size: 15px;">
              {{ $t("studentlist.endcycle_class_info") }}
            </p>
          </div>    
        </div>

        <!-- Message de succès après confirmation -->
        <div v-else class="modal-body pb-4">
          <div class="mb-3 text-center">
            <i class="fas fa-check-circle text-success me-2 fs-1"></i>
            <h5 class="modal-title mt-3 fw-bold text-center">
              {{ $t("studentlist.endcycle_success") }}
            </h5>
          </div>

          <div class="content mt-n2 w-60 text-center mx-auto">
            <p class="">
              {{ registrationNumbers.length }}
              {{ $t("studentlist.students_endcycle_success") }}
            </p>
          </div>
          
        </div>

        <div class="modal-footer border-0 pb-5 mb-1">
          <argon-button
            v-if="!isConfirmed"
            type="button"
            class="btn"
            :title="$t('button.close')"
            data-bs-dismiss="modal"
            @click="annuler"
            style="
              width: 200px;
              height: 50px;
              padding-top: 15px;
              background: none;
              border: 1px solid rgba(255, 255, 255, 0.4);
            "
          >
            <span>{{ $t("button.cancel") }}</span>
          </argon-button>
          <argon-button
            v-if="isConfirmed"
            type="button"
            class="btn"
            :title="$t('button.close')"
            data-bs-dismiss="modal"
            @click="annuler"
            style="
              width: 200px;
              height: 50px;
              padding-top: 15px;
              background: none;
              border: 1px solid rgba(255, 255, 255, 0.4);
            "
          >
            <span>{{ $t("button.close") }}</span>
          </argon-button>
          <argon-button
            v-if="!isConfirmed"
            @click="PromoteStudent"
            type="button"
            class="btn"
            color="success"
            variant="gradient"
            style="width: 200px; height: 50px; padding-top: 15px;  margin-right: 100px;"
            :loading="loading"
            :active="buttonActive || showConfirmation"
            :clickEvent="button"
          >
            <span v-if="!loading"> {{ $t("button.confirm") }}</span>
          </argon-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ArgonButton from "@/components/ArgonButton";
import { getGrades, PromoteStudent, getSpeciality } from "@/utils/services";
import config from "@/config.js";
import { toast } from "vue3-toastify";
import "vue3-toastify/dist/index.css";
export default {
  name: "Promote-Encycle",
  data() {
    return {
      showModal: false,
      loading: false,
      buttonActive: false,
      showConfirmation: false,
      selectedClass: "default",
      has_class: false,
      schoolList: [],
      allClassrooms: [],
      formSubmitted: false,
      isConfirmed: false,
      selectedClassObj: null,
      promote: config.ENDCYCLE,
    };
  },
  props: {
    registrationNumbers: {
      type: Array,
      required: true,
      default: () => [],
    },
     classroomId: {
      type: String,
      required: true,
    },
  },
  components: {
    ArgonButton,
    },

  async created() {
    try {
      this.loading = true;
      let response = await getGrades();
      this.schoolList = response.data;

      
      this.allClassrooms = [];
      this.schoolList.forEach((grade) => {
        if (grade.classrooms && grade.classrooms.length > 0) {
           
          const classroomsWithGrade = grade.classrooms.map((classroom) => {
            
            if (!classroom.number) {
              classroom.number = "";
            }

            return {
              ...classroom,
              gradeName: grade.name,
            };
          });

          this.allClassrooms = [...this.allClassrooms, ...classroomsWithGrade];
        }
      });

    
      this.has_class = this.allClassrooms.length > 0;
    } catch (err) {
      console.error("Failed to get Grades with classrooms", err);
    } finally {
      this.loading = false;
    }
  },

  methods: {
    selectClass(classroom) {
      this.selectedClass = classroom.id;
      this.selectedClassObj = classroom;
    },

    annuler() {
      this.resetState();
      this.$emit("cancel");
    },

    resetState() {
      this.showModal = false;
      this.loading = false;
      this.buttonActive = false;
      this.showConfirmation = false;
      this.selectedClass = "default";
      this.has_class = false;
      this.schoolList = [];
      this.allClassrooms = [];
      this.formSubmitted = false;
      this.isConfirmed = false;
      this.selectedClassObj = null;
      // Ajoutez ici d'autres propriétés à réinitialiser si besoin
    },

    async checkConnection() {
      try {
        await Promise.all([getGrades()]);
        this.apiError = false;
      } catch (error) {
        console.error("API Error:", error);
        this.apiError = true;
      }
    },
    async getData() {
      let grades = await getGrades();
      this.GRADE_CODE = grades.data;
      this.grade_code = "";
      this.grade_name = "";
      let specialities = await getSpeciality();
      this.SPECIALITY_CODE = specialities.data;
      this.speciality = "";
    },

    async PromoteStudent() {
      if (this.loading) {
        return;
      }
      this.formSubmitted = true;

       

      this.loading = true;

      try {
        let data = {
          action: this.promote,
          current_classroom_id: this.classroomId,
          new_classroom_id:"",
          registration_number_list: this.registrationNumbers,
        };

        let response = await PromoteStudent(data);

        if (response && response.status === 200) {
          this.isConfirmed = true;
          this.$emit("promotion-success");
        } else if (response && response.status === 404) {
          toast.error(this.$t("message.user404"), { autoClose: 3000 });
        } else if (response && response.status === 403) {
          toast.error(this.$t("new_class.impossible_add_class"), {
            autoClose: 3000,
          });
        } else {
          this.isConfirmed = true;
          this.$emit("promotion-success");
        }
      } catch (error) {
        console.error(
          "Erreur lors de la création de la salle de classe :",
          error
        );
      } finally {
        this.loading = false;
        this.buttonActive = false;
      }
    },
  },
};
</script>

<style scoped>
#span-number {
  height: 25px;
  width: 20px;
}
#select-class {
  height: 
  45px;
}
.directions {
  display: flex;
  width: max-content;
  gap: 15px;
}
</style>
